import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttopunecab() {



  const cardData =
  {
    keyword: ' Mumbai Airport to Pune Cab',
    heading: 'Sai Trupti Cabs: Mumbai Airport to Pune Cab',
    headingDescription: 'Sai Trupti Cabs offers seamless and comfortable Mumbai Airport to Pune cab services, designed to make your transfer from arrival to destination smooth and stress-free. Our fleet comprises well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all fitted with clean interiors and generous luggage space. Every journey is backed by a professional, background-verified chauffeur who ensures punctual pickup from any terminal at Chhatrapati Shivaji Maharaj International Airport in Mumbai, courteous service, and safe, relaxed driving all the way to Pune. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Mumbai Airport to Pune convenient, reliable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the historic pride of Pune, a grand fortress built in 1732 by the Peshwas during the Maratha Empire. Once the royal residence of Bajirao I, the fort echoes tales of bravery, politics, and power. Its massive Delhi Darwaza, intricate teakwood architecture, and sprawling courtyards reveal the city’s glorious past. Though ravaged by fire in 1828, the remaining stone walls and fountains still captivate visitors. The evening light-and-sound show beautifully narrates Pune’s journey from a Maratha capital to a modern metropolis. Shaniwar Wada remains the living symbol of Pune’s heritage and resilience."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is both a historical monument and a memorial to Mahatma Gandhi’s freedom struggle. Built in 1892 by Sultan Aga Khan III, this palace became the site of Gandhi’s internment during the Quit India Movement. The lush gardens, Italian arches, and tranquil courtyards radiate peace and dignity. Inside, the museum displays photographs, personal items, and ashes of Kasturba Gandhi. Every corner of this palace tells a story of sacrifice, patience, and patriotism. It’s not just a landmark — it’s a timeless tribute to India’s path to independence and Pune’s central role in it."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop the rugged Sahyadri mountains, is a monument to Maratha courage and strategic brilliance. Located 30 km from Pune, it’s famous for the valiant battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. The steep trek to the top rewards adventurers with breathtaking views of valleys and clouds drifting below. Along the way, local vendors serve hot pithla-bhakri and lemon juice, making the journey as flavorful as it is thrilling. At sunrise, the fort glows in golden light — a perfect blend of history, nature, and heroism."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved from basalt rock in the 8th century, Pataleshwar Cave Temple is a quiet sanctuary of devotion in the heart of Pune. Dedicated to Lord Shiva, its monolithic Nandi pavilion and stone pillars showcase ancient architectural mastery. Despite being centuries old, the temple radiates calm and continuity amid the city’s rush. Visitors come to meditate, admire the carvings, and feel connected to Pune’s spiritual roots. The cool, dim interior contrasts beautifully with the sunlight outside, making it a perfect escape for reflection and peace."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over the cityscape of Pune, offering a blend of faith and natural beauty. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 steps is both a spiritual and refreshing experience. The panoramic view from the summit, especially at dawn or dusk, reveals the city bathed in golden light. With the sound of temple bells and cool winds brushing past, Parvati Hill offers serenity high above the city’s bustle."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most famous and spiritually vibrant shrine, drawing millions of devotees each year. The stunning idol of Lord Ganesha, adorned with gold ornaments and flowers, exudes divine grace and energy. During Ganesh Chaturthi, the temple becomes the epicenter of celebration, music, and lights. The temple also runs various charitable trusts, embodying the spirit of giving and devotion. A visit here fills every heart with positivity, faith, and an unshakable sense of peace — a true reflection of Pune’s cultural soul."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a treasure chest of Indian art, tradition, and everyday creativity. Housing over 20,000 artifacts collected by Dr. Dinkar Kelkar, it tells stories of Indian life through musical instruments, sculptures, ornaments, and ancient household items. The recreated 17th-century Wada (mansion) exhibits the grandeur of old Marathi homes. Each gallery immerses visitors in a different era of design and craftsmanship. This museum is not just an archive — it’s an emotional journey through India’s cultural fabric."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Just 20 km from Pune, Khadakwasla Dam offers a perfect blend of nature, water, and tranquility. Built across the Mutha River, it serves as a popular picnic spot surrounded by rolling hills and cool breezes. Families, cyclists, and couples gather here to watch the sunset shimmer on the reservoir’s surface. Local food stalls add flavor with spicy bhajis and tea by the water. During monsoon, when the dam overflows, it transforms into a breathtaking sight. Khadakwasla is where Pune unwinds — peaceful, picturesque, and timeless."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Tucked away in the upscale Koregaon Park, Osho International Meditation Resort is a sanctuary of mindfulness and modern spirituality. Spread over 28 acres of lush gardens, it offers meditation programs, wellness therapies, and personal growth workshops. The blend of Zen-inspired architecture, flowing fountains, and serene walkways creates an atmosphere of inner balance. Visitors from around the world come to experience silence, awareness, and rejuvenation. Osho Ashram captures Pune’s global identity — spiritual yet contemporary, peaceful yet progressive."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s renowned Korakuen Garden, the Pune Okayama Friendship Garden — or Pu La Deshpande Udyan — represents harmony between two cultures. Spread across 10 acres, it features flowing streams, arched bridges, stone lanterns, and manicured lawns that embody tranquility. Named after the legendary Marathi writer Pu La Deshpande, the garden is a favorite spot for families, joggers, and photographers. The meticulous design and natural beauty make it an oasis of calm in the heart of the city, reflecting Pune’s aesthetic and cosmopolitan charm."
  }
],



  "services": [
    {
      "name": "Mumbai Airport to Pune Cab",
      "description": "Reliable cab service from Mumbai Airport to Pune with comfortable vehicles and professional drivers. Ideal for families, solo travelers, and corporate passengers, offering flexible pickup and drop points."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Service",
      "description": "Premium taxi service from Mumbai Airport to Pune. Well-maintained AC and Non-AC cars with experienced drivers ensure a safe and hassle-free journey. Perfect for one-way trips, round trips, or corporate travel."
    },
    {
      "name": "Mumbai Airport to Pune Car Hire",
      "description": "Hire a car from Mumbai Airport to Pune for leisure, business, or family trips. Options include AC and Non-AC vehicles, luggage assistance, and flexible timing for a smooth and comfortable ride."
    },
    {
      "name": "Mumbai Airport to Pune AC Cab",
      "description": "Travel in comfort with AC cabs from Mumbai Airport to Pune. Suitable for long-distance trips, corporate travel, and family journeys. Includes professional drivers, luggage support, and flexible pickups."
    },
    {
      "name": "Mumbai Airport to Pune Non AC Cab",
      "description": "Affordable Non-AC cab service from Mumbai Airport to Pune. Well-maintained vehicles, experienced drivers, luggage support, and online booking make it ideal for budget-conscious travelers."
    },
    {
      "name": "Luxury Cab Mumbai Airport to Pune",
      "description": "Premium luxury cab service from Mumbai Airport to Pune. Offers spacious and elegant vehicles with AC, professional drivers, luggage assistance, flexible pickup/drop points, and online booking for a seamless journey."
    },
    {
      "name": "Mumbai Airport to Pune Innova Cab",
      "description": "Spacious Innova cab service from Mumbai Airport to Pune, perfect for 6-7 passengers. Includes AC/Non-AC options, luggage support, professional drivers, and online booking for comfort and convenience."
    },
    {
      "name": "Mumbai Airport to Pune Ertiga Cab",
      "description": "Rent a 7-seater Ertiga cab from Mumbai Airport to Pune. Ideal for small groups or family travel, with AC/Non-AC options, professional drivers, luggage assistance, and online booking for a stress-free trip."
    },
    {
      "name": "Affordable Mumbai Airport to Pune Cab",
      "description": "Budget-friendly cab service from Mumbai Airport to Pune. Offers AC and Non-AC vehicles, experienced drivers, luggage support, online booking, and transparent pricing for a safe and cost-effective journey."
    },
    {
      "name": "Mumbai Airport to Pune Outstation Cab",
      "description": "Convenient outstation cab service from Mumbai Airport to Pune. Offers professional drivers, luggage assistance, AC/Non-AC vehicles, flexible pickup/drop points, and online booking for long-distance travelers."
    },
    {
      "name": "Mumbai Airport to Pune One Way",
      "description": "One-way cab service from Mumbai Airport to Pune for travelers seeking flexibility. Includes AC/Non-AC vehicles, Innova or Ertiga options, professional drivers, luggage support, and online booking for a hassle-free trip."
    },
    {
      "name": "Mumbai Airport to Pune Drop Cab",
      "description": "Safe and comfortable drop cab service from Mumbai Airport to Pune. Offers AC/Non-AC vehicles, professional drivers, luggage support, flexible pickup/drop locations, and transparent fares for a seamless ride."
    },
    {
      "name": "Mumbai Airport to Pune Corporate Cab",
      "description": "Corporate cab service from Mumbai Airport to Pune. AC and Non-AC vehicles, professional drivers, luggage support, flexible schedules, online booking, and transparent fares. Perfect for business trips and client meetings."
    },
    {
      "name": "Mumbai Airport to Pune Wedding Cab",
      "description": "Spacious and luxury cab service from Mumbai Airport to Pune for weddings and special events. Includes AC/Non-AC options, professional drivers, luggage assistance, flexible pickup/drop points, and online booking for smooth travel."
    },
    {
      "name": "Mumbai Airport to Pune Online Booking",
      "description": "Instant online booking of cabs from Mumbai Airport to Pune. Choose AC, Non-AC, Innova, Ertiga, or luxury vehicles with professional drivers, luggage support, flexible pickup/drop points, and transparent fares for a stress-free journey."
    }
  ],
  "tableData": [
    ["Mumbai Airport to Pune Cab", "Mumbai Airport to Pune Taxi Service"],
    ["Mumbai Airport to Pune Car Hire", "Mumbai Airport to Pune AC Cab"],
    ["Mumbai Airport to Pune Non AC Cab", "Luxury Cab Mumbai Airport to Pune"],
    ["Mumbai Airport to Pune Innova Cab", "Mumbai Airport to Pune Ertiga Cab"],
    ["Affordable Mumbai Airport to Pune Cab", "Mumbai Airport to Pune Outstation Cab"],
    ["Mumbai Airport to Pune One Way", "Mumbai Airport to Pune Drop Cab"],
    ["Mumbai Airport to Pune Corporate Cab", "Mumbai Airport to Pune Wedding Cab"],
    ["Mumbai Airport to Pune Online Booking", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai Airport to Pune Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Mumbai Airport to Pune — ideal for airport pickups, business trips, or leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one-way fares from Mumbai Airport to Pune are clear and affordable, with no hidden charges, ensuring a hassle-free journey."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, or Tempo Travellers to suit your group size, luggage, and travel preferences."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are familiar with the Mumbai Airport to Pune route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from Mumbai Airport (domestic or international terminals) and drop-offs at any location in Pune, including hotels, offices, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for the airport-to-city ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, flight schedule changes, route planning, or any travel assistance."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Mumbai Airport to Pune cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]



























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Mumbai Airport to Pune cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Mumbai Airport to Pune cab services for airport transfers, one-way trips, and round trips.',
  },
  {
    question: 'How can I book a cab from Mumbai Airport to Pune with Sai Trupti Cabs?',
    answer: 'You can easily book your Mumbai Airport to Pune cab through our website, mobile app, or by contacting our 24×7 customer support team for instant confirmation.',
  },
  {
    question: 'What types of cabs are available from Mumbai Airport to Pune?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Urbania, and Tempo Travellers to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Mumbai Airport to Pune trips?',
    answer: 'Yes, all our drivers are professional, courteous, and trained for long-distance and airport transfers, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Mumbai Airport to Pune for family, corporate, or group travel?',
    answer: 'Certainly. Our cab services cater to family trips, corporate travel, group tours, and airport pickups/drop-offs.',
  },
  {
    question: 'Is the Mumbai Airport to Pune cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Mumbai Airport to Pune to fit your flight schedule and travel plans.',
  },
  {
    question: 'What are the fares for Mumbai Airport to Pune cab services?',
    answer: 'Cab fares from Mumbai Airport to Pune start from approximately ₹1,300 for sedans and ₹1,800–₹2,500 for SUVs and larger vehicles, depending on vehicle type, distance, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for Mumbai Airport to Pune cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Mumbai Airport to Pune cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during Mumbai Airport to Pune cab trips?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you before, during, and after your Mumbai Airport to Pune cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Deshmukh',
    feedback: 'I booked a cab from Mumbai Airport to Pune with Sai Trupti Cabs. The driver was on time, the ride was smooth, and the service was excellent.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Riya Kulkarni',
    feedback: 'Sai Trupti Cabs made my Mumbai Airport to Pune trip very comfortable and hassle-free. Highly recommended for airport transfers.',
    rating: 5,
  },
];













































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cab",
  "image": "https://saitrupticabs.com/assets/images/mumbai-airport-to-pune-cab.jpg",
  "description": "Book Mumbai Airport to Pune cabs with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, round trips, corporate travel, weddings, or outstation trips. Reliable and affordable online cab booking 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1420"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/mumbai-airport-to-pune-cab"
  }
};




  return (
    <div>
      <Helmet>
  <title>Mumbai Airport to Pune Cab | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport to Pune cabs with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, round trips, corporate travel, weddings, or outstation trips. Reliable and affordable online cab booking 24x7." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Airport to Pune Cab, Mumbai Airport to Pune Taxi Service, Mumbai Airport to Pune Car Hire, Mumbai Airport to Pune AC Cab, Mumbai Airport to Pune Non AC Cab, Luxury Cab Mumbai Airport to Pune, Mumbai Airport to Pune Innova Cab, Mumbai Airport to Pune Ertiga Cab, Affordable Mumbai Airport to Pune Cab, Mumbai Airport to Pune Outstation Cab, Mumbai Airport to Pune One Way, Mumbai Airport to Pune Drop Cab, Mumbai Airport to Pune Corporate Cab, Mumbai Airport to Pune Wedding Cab, Mumbai Airport to Pune Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunecab;